import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const TABS = [
  { key: "", label: "All" },
  { key: "pending", label: "Pending" },
  { key: "approved", label: "Approved" },
  { key: "rejected", label: "Rejected" },
  { key: "suspended", label: "Suspended" },
];

const COLORS = {
  pending: "bg-amber-100 text-amber-700",
  approved: "bg-green-100 text-green-700",
  rejected: "bg-red-100 text-red-700",
  suspended: "bg-red-100 text-red-700",
};

export default function AdminVendors() {
  const [tab, setTab] = useState("pending");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/admin/vendors${tab ? `?status=${tab}` : ""}`);
      setItems(data);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [tab]);

  const act = async (id, action) => {
    try {
      await api.patch(`/admin/vendors/${id}`, { action });
      toast.success(`Vendor ${action}d`);
      load();
    } catch { toast.error("Action failed"); }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="text-xs uppercase tracking-[0.2em] text-[#14A085]">Admin</div>
      <h1 className="font-display text-3xl md:text-4xl text-[#0F3D2E]">Vendor Applications</h1>

      <div className="mt-6 flex gap-2 flex-wrap" data-testid="vendor-tabs">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)} className={`px-4 py-1.5 rounded-full text-sm ${tab===t.key ? "bg-[#0F3D2E] text-white" : "bg-white text-[#0F3D2E] border border-[#E2E8E5] hover:border-[#14A085]"}`} data-testid={`tab-${t.key || "all"}`}>
            {t.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="mt-8 text-center text-[#3B5249]">Loading…</div>
      ) : items.length === 0 ? (
        <div className="mt-8 rounded-xl border border-dashed border-[#E2E8E5] bg-white p-12 text-center">No vendors here.</div>
      ) : (
        <div className="mt-6 space-y-3" data-testid="admin-vendors-list">
          {items.map((v) => (
            <div key={v.id} className="rounded-xl border border-[#E2E8E5] bg-white p-5" data-testid={`av-${v.id}`}>
              <div className="flex flex-wrap justify-between gap-3">
                <div>
                  <div className="flex items-center gap-2">
                    <span className={`text-xs px-2 py-0.5 rounded-full capitalize ${COLORS[v.status]}`}>{v.status}</span>
                    <span className="text-xs text-[#6E877C]">{v.business_type}</span>
                  </div>
                  <div className="mt-1 font-display text-xl text-[#0F3D2E]">{v.business_name}</div>
                  <div className="text-sm text-[#3B5249]">{v.owner_name} · {v.email} · {v.phone}</div>
                  <div className="text-xs text-[#6E877C] mt-1">PAN: {v.pan} {v.gstin ? `· GSTIN: ${v.gstin}` : ""}</div>
                  <div className="text-xs text-[#6E877C]">{v.address_line}, {v.city}, {v.state} - {v.pincode}</div>
                  <div className="text-xs text-[#6E877C]">Bank: {v.account_holder} · {v.bank_account} · {v.ifsc}</div>
                </div>
                <div className="flex flex-col gap-2">
                  {v.status !== "approved" && <button onClick={() => act(v.id, "approve")} className="px-4 py-1.5 rounded-full bg-[#0F3D2E] hover:bg-[#14A085] text-white text-sm" data-testid={`approve-v-${v.id}`}>Approve</button>}
                  {v.status !== "rejected" && <button onClick={() => act(v.id, "reject")} className="px-4 py-1.5 rounded-full border border-red-300 text-red-600 hover:bg-red-50 text-sm" data-testid={`reject-v-${v.id}`}>Reject</button>}
                  {v.status === "approved" && <button onClick={() => act(v.id, "suspend")} className="px-4 py-1.5 rounded-full border border-amber-300 text-amber-700 hover:bg-amber-50 text-sm">Suspend</button>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
